var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{class:'flow-graph '+'weight-'+_vm.weight},[_c('path',{attrs:{"stroke-width":"3","d":_vm.path,"fill":"none"}})])}
var staticRenderFns = []

export { render, staticRenderFns }